import React, { FunctionComponent, useState } from 'react'
import * as S from './styled'
import { ReactComponent as PdfIcon } from '../../atoms/Icons/pdf.svg'
import { ReactComponent as MenuIcon } from '../../atoms/Icons/dotdotdot.svg'
import Lantmannen from '../../atoms/Icons/lantmannen-logo.png'
import Dava from '../../atoms/Icons/dava.png'
import Kgs from '../../atoms/Icons/kgs.jpg'
import Kron from '../../atoms/Icons/kron.png'
import BmAgri from '../../atoms/Icons/bm-agri.jpg'
import SvenskaFoder from '../../atoms/Icons/svenska_foder.jpg'
import { BoldText } from '../../../theme/typography'
import { ProductData } from '../../../redux/requests/products/product.types'
import ActionMenu from '../../atoms/ActionMenu/ActionMenu'
import { useDispatch, useSelector } from 'react-redux'
import { requestActions } from '../../../redux/requests'
import { MainState } from '../../../redux/reducers'
import OutsideAlerter from '../../../hooks/OutsideAlerter'
import { PageRoute } from '../../../navigation/constants'
import { NavLink } from 'react-router-dom'
import { useHistory } from 'react-router'
type OwnProps = {
  doc: ProductData
  data: ProductData[]
  setDataState: React.Dispatch<React.SetStateAction<ProductData[]>>
  listView: boolean
}

type Props = OwnProps

export const DocumentCard: FunctionComponent<Props> = ({ doc, data, setDataState, listView }) => {
  const uid = useSelector((state: MainState) => state.misc.uid)
  const history = useHistory()
  const [showMenu, setShowMenu] = useState(false)
  const dispatch = useDispatch()
  const clickHandler = (option: string) => {
    if (option === 'remove') {
      dispatch(requestActions.products.deleteDocument(uid!, doc.id))
      const pendingDeletion: any = localStorage.getItem('pendingDeletion')
      let pendingDeletionParse = []
      if (pendingDeletion !== null) {
        pendingDeletionParse = JSON.parse(pendingDeletion)
      }
      localStorage.setItem('pendingDeletion', JSON.stringify([...pendingDeletionParse, doc.id]))

      data = data.filter(d => d.id !== doc.id)
      setDataState(data)
      setShowMenu(false)
    }
    if (option === 'update') {
      history.push(`/updatedocument/${doc.id}`)
    }
  }
  const logoMap = {
    DAVA: Dava,
    KGS_AGG: Kgs,
    KRON: Kron,
    BM_AGRI: BmAgri,
    LANTMANNEN: Lantmannen,
    SV_FODER: SvenskaFoder,
    LANTMANNEN_FODER: Lantmannen,
  }
  const actionMenuOptions = [
    { func: 'remove', name: 'Ta bort' },
    { func: 'update', name: 'Ändra' },
  ].slice(0, doc.product !== 'eggs' ? 1 : undefined)
  return (
    <>
      <S.Container>
        {!listView && (
          <S.Card>
            {showMenu && (
              <OutsideAlerter setShowMenu={setShowMenu}>
                <ActionMenu
                  options={actionMenuOptions}
                  clickHandler={(option: string) => clickHandler(option)}
                />
              </OutsideAlerter>
            )}
            <S.Button className="hide" onClick={() => setShowMenu(!showMenu)}>
              <MenuIcon />
            </S.Button>
            <NavLink to={`${PageRoute.DOCUMENTS}/${doc.id}/${doc.product}`} exact>
              <BoldText>{doc.fileName}</BoldText>
            </NavLink>
            <BoldText fontSize={'12px'}>{translateProduct(doc.product)}</BoldText>
            <BoldText fontSize={'12px'}>datum: {doc.settlementDate}</BoldText>
            <BoldText fontSize={'12px'}>uppladdat av: {doc.uploadedBy}</BoldText>
          </S.Card>
        )}

        {listView && (
          <S.ListCard>
            <NavLink to={`${PageRoute.DOCUMENTS}/${doc.id}/${doc.product}`} exact>
              <BoldText>{doc.fileName}</BoldText>
            </NavLink>
            <BoldText>{translateProduct(doc.product)}</BoldText>
            <BoldText>{doc.uploadedBy}</BoldText>
            <BoldText>{doc.settlementDate}</BoldText>
            {showMenu && (
              <OutsideAlerter setShowMenu={setShowMenu}>
                <ActionMenu
                  options={actionMenuOptions}
                  clickHandler={(option: string) => clickHandler(option)}
                />
              </OutsideAlerter>
            )}
            <S.Button className="hide" onClick={() => setShowMenu(!showMenu)} listView>
              <MenuIcon />
            </S.Button>
          </S.ListCard>
        )}
      </S.Container>
      <S.CardMobile>
        {showMenu && (
          <OutsideAlerter setShowMenu={setShowMenu}>
            <ActionMenu
              options={actionMenuOptions}
              clickHandler={(option: string) => clickHandler(option)}
            />
          </OutsideAlerter>
        )}
        <S.Button className="hide" onClick={() => setShowMenu(!showMenu)}>
          <MenuIcon />
        </S.Button>
        <PdfIcon />
        <NavLink to={PageRoute.DOCUMENTS + '/' + doc.id} exact>
          <BoldText>{doc.fileName}</BoldText>
        </NavLink>
        <BoldText fontSize={'12px'}>datum: {doc.settlementDate}</BoldText>
        <BoldText fontSize={'12px'}>uppladdat av: {doc.uploadedBy}</BoldText>
      </S.CardMobile>
    </>
  )
}

const translateProduct = (product: string) => {
  return (
    {
      eggs: 'Ägg',
      oats: 'Havre',
      rapeseed: 'Raps',
      raps: 'Raps',
      foder: 'Foder',
      diesel: 'Diesel',
    }[product] ?? product
  )
}
